import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitBooking = (data) => api.post("/bookings", data).then((r) => r.data);

export const adminLogin = (password) =>
  api.post("/admin/login", { password }).then((r) => r.data);

export const fetchBookings = (token) =>
  api.get("/admin/bookings", { headers: { "X-Admin-Token": token } }).then((r) => r.data);

export const fetchAnalytics = (token) =>
  api.get("/admin/analytics", { headers: { "X-Admin-Token": token } }).then((r) => r.data);

export const updateBookingStatus = (id, status, token) =>
  api
    .patch(
      `/admin/bookings/${id}/status`,
      { status },
      { headers: { "X-Admin-Token": token } }
    )
    .then((r) => r.data);

export const deleteBooking = (id, token) =>
  api
    .delete(`/admin/bookings/${id}`, { headers: { "X-Admin-Token": token } })
    .then((r) => r.data);

// ---- Performances ----
export const fetchPerformances = () =>
  api.get("/performances").then((r) => r.data);

export const createPerformance = (data, token) =>
  api
    .post("/admin/performances", data, { headers: { "X-Admin-Token": token } })
    .then((r) => r.data);

export const updatePerformance = (id, data, token) =>
  api
    .patch(`/admin/performances/${id}`, data, { headers: { "X-Admin-Token": token } })
    .then((r) => r.data);

export const deletePerformance = (id, token) =>
  api
    .delete(`/admin/performances/${id}`, { headers: { "X-Admin-Token": token } })
    .then((r) => r.data);

// ---- Rad van Fortuin ----
export const spinWheel = (sessionId, device) =>
  api.post("/rad/spin", { session_id: sessionId, device }).then((r) => r.data);

export const fetchRadStats = (token) =>
  api.get("/admin/rad/stats", { headers: { "X-Admin-Token": token } }).then((r) => r.data);

export const fetchRadSpins = (token) =>
  api.get("/admin/rad/spins", { headers: { "X-Admin-Token": token } }).then((r) => r.data);
